import React from 'react';
import './App.css';
import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import {ToastContainer} from "react-toastify";
import LoginScreen from "./screens/mainscreen/LoginScreen";
import RegisterScreen from "./screens/mainscreen/RegisterScreen";

import SettingsScreen from "./screens/admin/SettingsScreen";

import VerifyEmailScreen from "./screens/admin/VerifyEmailScreen";
import ForgotPasswordPage from "./screens/admin/ForgotPasswordPage";
import PasswordResetScreen from "../src/screens/admin/PasswordResetScreen";

import ConstructionLandingPage from "../src/screens/AttendenceScreen/ConstructionLandingPage";
import SignInSuccessScreen from "../src/screens/AttendenceScreen/SignInSuccessScreen";
import SignOutSuccessScreen from "../src/screens/AttendenceScreen/SignOutSuccessScreen";
import EmployeeClockScreen from "../src/screens/AttendenceScreen/EmployeeClockScreen";
import EmployeeWeeklyTimesheetScreen from "./screens/AttendenceScreen/EmployeeWeeklyTimesheetScreen";
import EmployeeListScreen from "../src/screens/AttendenceScreen/EmployeeListScreen";
import WeeklyTimeSheetScreen from "../src/screens/AttendenceScreen/WeeklyTimeSheetSceen";
import UserTableScreen from "../src/screens/admin/UserTableScreen";
import EmployeeRegistrationScreen from "../src/screens/AttendenceScreen/EmployeeRegistrationScreen"
import EmployeeProfile from "./screens/AttendenceScreen/EmployeeProfileScreen";
import DashboardScreen from "../src/screens/AttendenceScreen/DashboardScreen";
import ProjectSelectionScreen from "../src/screens/AttendenceScreen/ProjectSelectionScreen";
import EmployeeLoginScreen from "../src/screens/AttendenceScreen/EmployeeLoginScreen";
import {
    AssignEmployeeToProject
} from "../src/screens/AttendenceScreen/AssignEmployeeToProject";

function App() {
  return (
    <>
        <Router>
            <ToastContainer />

            <Routes>
                <Route path="/login" element={<LoginScreen />} />
                <Route path={"employeeLogin"} element={<EmployeeLoginScreen />} />
                <Route path="/register" element={<RegisterScreen />} />
                <Route path={"/settings"} element={<SettingsScreen />} />
                <Route path={"/verifyEmail"} element={<VerifyEmailScreen />} />
                <Route path={"/forgotPassword"} element={<ForgotPasswordPage />} />
                <Route path={"/resetPassword"} element={<PasswordResetScreen />} />
                <Route path={"/"} element={<ConstructionLandingPage/>} />
                <Route path={"signIn"} element={<SignInSuccessScreen/>}/>
                <Route path={"signOut"} element={<SignOutSuccessScreen/>}/>
                <Route path={"/clockin"} element={<EmployeeClockScreen />} />

                <Route path={"/management"} element={<ProjectSelectionScreen />} />
                <Route path={"/management/employeeMain/:id"} element={<EmployeeWeeklyTimesheetScreen />} />
                <Route path={"/management/employeeList/:id"} element={<EmployeeListScreen />} />
                <Route path={"/management/users/:id"} element={<UserTableScreen />} />
                <Route path={"/management/weeklytimesheet/:id"} element={<WeeklyTimeSheetScreen />} />

                <Route path={"createEmployee/:id"} element={<EmployeeRegistrationScreen />} />
                <Route path={"/profile/:id/:id"} element={<EmployeeProfile/>} />
                <Route path={"/dashboard"} element={<DashboardScreen />} />
                <Route path={"management/assign/:id"} element={<AssignEmployeeToProject />} />


            </Routes>

        </Router>



    </>
  );
}

export default App;
